import _MpResult from "./MpResult.jsx"
import withInstall from "../../utils/withInstall"

export const MpResult = withInstall(_MpResult)
export default MpResult
